module.exports = __webpack_public_path__ + "static/media/chevron-circle-right.0d443f06.svg";